import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize, take } from 'rxjs/operators';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

import { BrowserService } from '@service/browser.service';
import { DocumentService } from './document.service';

import { ErrorCode, ErrorType } from '@enum/error.enum';

import { ErrorResponse } from '@model/error.model';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {
  loading = false;
  documentSrc: Blob;
  documentPassword: string;

  modalRef: BsModalRef;
  @ViewChild('passwordModal') passwordModal: TemplateRef<any>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private platformLocation: PlatformLocation,
    private modalService: BsModalService,
    private browserService: BrowserService,
    private documentService: DocumentService
  ) {}

  ngOnInit(): void {
    this.getDocument();
    this.platformLocation.onPopState(() => this.modalRef.hide());
  }

  submitPassword(password: string): void {
    this.documentPassword = password;
    this.modalRef.hide();
  }

  private getDocument(): void {
    this.loading = true;
    const epolicyId: string = this.route.snapshot.paramMap.get('documentInfo');

    this.documentService
      .downloadPolicy(epolicyId)
      .pipe(
        take(1),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        next: (data: BlobPart) => {
          this.displayDocument(data);
        },
        error: (e: ErrorResponse) => {
          if (e && e.code === ErrorCode.LINKEXPIRED) {
            this.router.navigate([`error/${ErrorType.LINKEXPIRED}`]);
          } else {
            this.router.navigate([`error/${ErrorType.CANNOTDOWNLOAD}`]);
          }
        }
      });
  }

  private displayDocument(blob: BlobPart): void {
    if (this.browserService.isIEBrowser()) {
      const navigator: any = window.navigator;
      navigator.msSaveOrOpenBlob(blob);
    } else {
      const contractBlob: Blob = new Blob([blob], { type: 'application/pdf' });
      this.documentSrc = contractBlob;
      this.openPasswordModal();
    }
  }

  private openPasswordModal(): void {
    const modalOptions: ModalOptions = {
      backdrop: 'static',
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered'
    };
    this.modalRef = this.modalService.show(this.passwordModal, modalOptions);
  }
}
